// Query hooks barrel export
// Re-export all query hooks from this directory

export { useLevelsQuery } from './use-levels-query';
export type { Level } from './use-levels-query';

export { useHolidaysQuery } from './use-holidays-query';
export type { Holiday } from './use-holidays-query';

export { useSlotAvailabilitiesQuery, slotAvailabilitiesKeys } from './use-slot-availabilities-query';
export type { SlotAvailability, TimeRange } from './use-slot-availabilities-query';

export {
  useNotificationSettingsQuery,
  useUpdateNotificationSettingsMutation,
  notificationSettingsKeys,
} from './use-notification-settings-query';
export type { NotificationSetting, NotificationType, EmailSetting } from './use-notification-settings-query';

export {
  useBillingHistoryQuery,
  useBillingHistoryItemQuery,
  useUnpaidInvoiceQuery,
  usePayInvoiceMutation,
  billingHistoryKeys,
} from './use-billing-history-query';
export type { BillingHistoryItem, UnpaidInvoice } from './use-billing-history-query';

export {
  useStudentLessonsWithIssueQuery,
  useTutorLessonsWithIssueQuery,
  lessonsWithIssueKeys,
} from './use-lessons-with-issue-query';
export type { LessonWithIssue } from './use-lessons-with-issue-query';

export {
  useTutorEducationsQuery,
  useMyEducationsQuery,
  useCreateEducationMutation,
  useUpdateEducationMutation,
  useDeleteEducationMutation,
} from './use-tutor-education-query';
export type { TutorEducation } from './use-tutor-education-query';

export {
  useTutorCertificationsQuery,
  useMyCertificationsQuery,
  useCreateCertificationMutation,
  useUpdateCertificationMutation,
  useDeleteCertificationMutation,
} from './use-tutor-certification-query';
export type { TutorCertification } from './use-tutor-certification-query';

export {
  useTutorInterestsQuery,
  useMyInterestsQuery,
  useCreateInterestMutation,
  useDeleteInterestMutation,
} from './use-user-interests-query';
export type { UserInterest } from './use-user-interests-query';
